import { Card, Col, Row } from 'antd';
import VersaBuiltTable from '../../components/VersaBuiltTable';
import Header from '../../components/Header';
import { Link } from 'react-router-dom';

function VersaBuilt() {
	return (
		<>
			<Header
				title="Versabuilt"
				breadcrumbItems={[
					{
						title: <Link to="/">Home</Link>,
					},
					{
						title: 'Versabuilt',
					},
				]}
			/>
			<Row>
				<Col span={24}>
					<Card className="shadow-sm" bodyStyle={{ padding: 0 }}>
						<VersaBuiltTable />
					</Card>
				</Col>
			</Row>
		</>
	);
}

export default VersaBuilt;
